module.exports = __webpack_public_path__ + "static/media/bottle.efc9f765.png";